import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Image } from '@com-delta-idp/mnx-ui-kit';
import { DisplayManagerService } from '../../services/display-manager.service';
import {
  SCREEN_VIEW,
  Slide,
  WelcomeTour
} from './models/welcome-tour.interfaces';

@Component({
  selector: 'idp-welcome-tour',
  templateUrl: './welcome-tour.component.html',
  styleUrls: ['./welcome-tour.component.scss'],
  providers: [DisplayManagerService],
  encapsulation: ViewEncapsulation.None
})
export class WelcomeTourComponent implements AfterViewInit {
  @Input() content: WelcomeTour = {} as WelcomeTour;
  @Output() closeModal = new EventEmitter<boolean>();

  constructor(public displayManagerService: DisplayManagerService) {}

  @HostListener('window:resize', ['$event'])
  mobileScreen() {
    return window.innerWidth <= SCREEN_VIEW.MOBILE;
  }

  getImage(desktop: Image, mobile: Image) {
    if (this.mobileScreen()) return mobile;
    else return desktop;
  }

  ngAfterViewInit(): void {
    this.displayManagerService.init(0);
  }

  getAriaLabels(slide: Slide[]): string[] {
    const ariaLabels: string[] = [];
    slide.forEach((_slides: Slide) => {
      ariaLabels.push(_slides.content.title);
    });
    return ariaLabels;
  }

  notifyClose() {
    this.closeModal.emit();
  }
}
